import { Injectable, inject, signal } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Database, ref, listVal } from "@angular/fire/database";
import { Observable } from "rxjs";

@Injectable()
export class TransConfigService {
  private readonly mdb = inject(Database);
  languages: Observable<any[]>;
  // Elements are {code, name, localizedName, …} objects from /config/languages.
  // Signal so the async Firebase write is CD-coordinated under zoneless — a
  // plain field set in the subscribe callback never re-rendered the language
  // <select> when the data arrived after the profile dialog opened.
  private readonly languagesSig = signal<any[]>([]);

  get latestLanguages(): any[] {
    return this.languagesSig();
  }

  constructor(private trans: TranslateService) {
    this.languages = listVal<any>(ref(this.mdb, "config/languages"));
    this.languages.subscribe((results) => {
      results.sort((a, b) => {
        if (a.localizedName < b.localizedName) {
          return -1;
        }
        if (a.localizedName > b.localizedName) {
          return 1;
        }
        return 0;
      });
      this.languagesSig.set(results);
    });
  }
}
